import { NgModule } from '@angular/core';

import { TimezoneAutocompleteMultipleSelectsComponent } from './timezone-autocomplete-multiple-selects.component';

@NgModule({
  imports: [TimezoneAutocompleteMultipleSelectsComponent],
  exports: [TimezoneAutocompleteMultipleSelectsComponent]
})
export class TimezoneAutocompleteMultipleSelectsModule {}
